/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_IntroInputs */

const en_planner_intro = /** @type {(inputs: Planner_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dishly suggests a week from your recipes. You can change the draft before it goes into the plan.`)
};

const de_planner_intro = /** @type {(inputs: Planner_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dishly schlägt aus euren Rezepten eine Woche vor. Den Entwurf kannst du anpassen, bevor er in den Plan kommt.`)
};

/**
* | output |
* | --- |
* | "Dishly suggests a week from your recipes. You can change the draft before it goes into the plan." |
*
* @param {Planner_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_intro = /** @type {((inputs?: Planner_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_intro(inputs)
	return en_planner_intro(inputs)
});